import Row from './row';
import Col from './col';
export { Row, Col };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/grid/index.js
// module id = 146
// module chunks = 0